import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataFetched: false,
  eventStatusList: null,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "commandDetailPage",
  initialState: initialState,
  reducers: {
    getCommandDetailPageData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    getEventStatusListData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    getCommandDetailPageDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.dataFetched = true;
      state.eventStatusList = action.payload.data?.data?.ACTION_LIST;
    },
    getCommandDetailPageDataError: (state, action) => {
      state.error = action.payload;
      state.dataFetched = false;
      state.loading = false;
    },
    sendCommand: (state, action) => {
      state.error = null;
      state.loading = true;
      state.dataFetched = false;
    },
    commandDetailPageResetState: () => initialState,
  },
});

export const {
  getCommandDetailPageData,
  getEventStatusListData,
  getCommandDetailPageDataSuccess,
  getCommandDetailPageDataError,
  sendCommand,
  commandDetailPageResetState,
} = slice.actions;

export default slice.reducer;
